import Power1W from "./containers/Power1W";
export default Power1W;